module.exports = __webpack_public_path__ + "img/twitter.25cf1512.svg";